module.exports = __webpack_public_path__ + "static/img/joinBanner5.7b79279.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/join/joinBanner5.jpg
// module id = RkCb
// module chunks = 0